import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';

function FeesInformation({
  transactionInfo,
}) {
  const feesList = get(transactionInfo, 'included.module.attributes.transaction_fees', '--');

  return (
    <>
      <div className="p-3">
        <div style={{overflowX: 'auto'}}>
          <table className="transaction-table table table-bordered table-sm">
            <thead>
              <tr>
                <th className="text-center">Fee</th>
                <th className="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              {feesList.map((item) => {
                return (
                  <React.Fragment>
                    <tr key={item.id}>
                      <td className='capitalize'>
                        <h5>
                          {get(item, 'name') || '--'}
                        </h5>
                      </td>
                      <td className="text-right">
                        <h5>
                          {get(item, 'amount') || '--'}
                        </h5>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
              <tr>
                <td className="text-right">
                  <h5>
                    <b>Total</b>  
                  </h5>
                </td>
                <td className="text-right">
                  <h5>
                    <b>{get(transactionInfo, 'attributes.amount', '0.00')}</b>
                  </h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

FeesInformation.propTypes = {
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
};

export default FeesInformation;
